export enum NoteDirection {
    Sent,
    Received
}